import { render, staticRenderFns } from "./TasksCharts.component.vue?vue&type=template&id=069311a1&scoped=true&"
import script from "./TasksCharts.component.vue?vue&type=script&lang=js&"
export * from "./TasksCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./TasksCharts.component.vue?vue&type=style&index=0&id=069311a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069311a1",
  null
  
)

export default component.exports